var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "system-simulation-payment" },
    [
      _c("div", { staticClass: "page-title application-detail-header" }, [
        _vm._v(" " + _vm._s(_vm.$t("menu.simulation_collection_verify")) + " "),
      ]),
      _c("p", { staticStyle: { color: "red", "white-space": "pre-line" } }, [
        _vm._v(_vm._s(_vm.$t("system.simulation_collection_verify_warning"))),
      ]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "text item" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  model: _vm.search,
                  "label-width": "150px",
                  rules: _vm.rules,
                  "label-position": "left",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("system.mch_order_id"),
                      prop: "mch_order_id",
                      required: "",
                    },
                  },
                  [
                    _c("el-input", {
                      staticClass: "search-frame",
                      attrs: {
                        size: "small",
                        placeholder: _vm.$t("system.mch_order_id"),
                        autocomplete: "off",
                        clearable: "",
                      },
                      model: {
                        value: _vm.search.mch_order_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "mch_order_id", $$v)
                        },
                        expression: "search.mch_order_id",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("system.amount"),
                      prop: "amount",
                      required: "",
                    },
                  },
                  [
                    _c("el-input", {
                      staticClass: "search-frame",
                      attrs: {
                        size: "small",
                        placeholder: _vm.$t("system.amount"),
                        autocomplete: "off",
                        clearable: "",
                      },
                      model: {
                        value: _vm.search.amount,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "amount", $$v)
                        },
                        expression: "search.amount",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", disabled: _vm.listLoading },
                        on: {
                          click: function ($event) {
                            return _vm.onSubmit("form")
                          },
                        },
                      },
                      [_vm._v("Submit")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }